import React from 'react';
import { GoalsScreen } from './GoalsScreen';
import './GoalsWithTabsScreen.css';

export const GoalsWithTabsScreen: React.FC = () => {
  return (
    <div className="goals-with-tabs-screen">
      {/* Goals Content */}
      <div className="goals-content">
        <div className="goals-tab-content">
          <GoalsScreen />
        </div>
      </div>
    </div>
  );
};
